/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-redux/prefer-separate-component-file */
/* eslint-disable react-redux/connect-prefer-named-arguments */
/* eslint-disable import/no-default-export */
import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import { ValidationIcon } from 't3-widgets'

import { DeviceTypeHandler } from '../../../../../common/components/device-type-handler/device-type-handler'
import { TEST_DISABLED_ACTIVATION_ON_BACKEND } from '../../../../../common/constants'
import {
    setDeviceActivationKey,
    setSelectedSubscriptionOption,
    setSubscriptionSelectedPage,
    setDeviceSerialNumber,
    setRmaDeviceSerialNumber
} from '../../../../../redux/actions'

import styles from '../pages/pages.module.css'

const FinishPage = ({
    deviceSerialNumber,
    intl,
    setDeviceActivationKey,
    setDeviceSerialNumber,
    setPagerFunctions,
    setRmaDeviceSerialNumber,
    setSelectedSubscriptionOption,
    setStep,
    setSubscriptionSelectedPage
}) => {
    const onFinish = () => {
        setSelectedSubscriptionOption(false)
        setSubscriptionSelectedPage('wfsubscription')
        setRmaDeviceSerialNumber('')
        setDeviceActivationKey('')
        setDeviceSerialNumber('')
        setStep(0)
    }

    useEffect(() => {
        setPagerFunctions({
            onBack: null,
            onFinish: () => onFinish(),
            validator: true
        })
    }, [])

    return (
        <div>
            <div className={styles['activated-text']}>
                {intl.translate('ap_step5_label')}. {intl.translate('ap_finish_message')} ({deviceSerialNumber})
            </div>
            <div className={styles['vertical-align-success-container']}>
                <div className={styles['vertical-align-item-finish']}>
                    <ValidationIcon width="15vw" className={styles['validation-icon-success']} inheritColor />
                </div>
            </div>
            <div className={styles['note-container']}>
                {intl.translate('ap_generic_note')}
                {TEST_DISABLED_ACTIVATION_ON_BACKEND
                    ? ' Activation request to backend blocked due to test purposes.' +
                      ' If you want to perform true activation, change TEST_DISABLED_ACTIVATION_ON_BACKEND' +
                      ' flag in constants'
                    : intl.translate('ap_step5_para_2')}
                <div>
                    <DeviceTypeHandler
                        desktopDeviceComponent=""
                        mobileDeviceComponent={intl.translate('ap_finish_mobile_qr')}
                    />
                </div>
            </div>
        </div>
    )
}

const mapStateToProps = state => {
    const { deviceSerialNumber } = state.deviceSerialNumber || ''
    return { deviceSerialNumber }
}

FinishPage.propTypes = {
    deviceSerialNumber: PropTypes.string,
    intl: PropTypes.objectOf(PropTypes.func),
    setDeviceActivationKey: PropTypes.func,
    setDeviceSerialNumber: PropTypes.func,
    setPagerFunctions: PropTypes.func,
    setRmaDeviceSerialNumber: PropTypes.func,
    setSelectedSubscriptionOption: PropTypes.func,
    setStep: PropTypes.func,
    setSubscriptionSelectedPage: PropTypes.func
}

export default connect(mapStateToProps, {
    setDeviceActivationKey,
    setDeviceSerialNumber,
    setRmaDeviceSerialNumber,
    setSelectedSubscriptionOption,
    setSubscriptionSelectedPage
})(FinishPage)
